import Dialog from '@common/Dialog';
import cx from 'classnames';
import XCircleIcon from '@heroicons/react/24/outline/XCircleIcon';

const Popup = (props) => {
    const {
        data, storeConfig, open, ContentImage, ContentCustom,
        handleClosePopup, closeOutside, withbackdrop, overlayBackground, cornerStyle,
        popupShadow, animation, verticalPositionStyle, horizontalPositionStyle, customCss,
        deviceType, popupWidth, popupRef, handleSendmatrixOutsideClick,
    } = props;

    return (
        <>
            {deviceType && (
                <Dialog
                    open={open}
                    variant="plain"
                    classWrapper={cx(
                        'w-full h-fit top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
                        overlayBackground === '4' ? '!absolute !z-[1]' : '',
                        `campaign_${data.cookie_id}`,
                    )}
                    backdrop={withbackdrop}
                    closeOnBackdrop={closeOutside}
                    closeOutsideContent={closeOutside}
                    onClose={() => {
                        if (closeOutside) {
                            handleClosePopup(data);
                            handleSendmatrixOutsideClick();
                        }
                    }}
                    backdropClassName={cx(
                        overlayBackground === '1' ? '!bg-neutral-white opacity-50' : '',
                    )}
                    hideOverflow={false}
                    style={{
                        ...verticalPositionStyle,
                        ...horizontalPositionStyle,
                    }}
                >
                    <div
                        className={cx(
                            'swift-campaign-popup relative bg-neutral-white md:m-4 xs:m-4 w-[100%] p-3 !m-0 min-w-fit',
                            popupShadow === '1' ? 'shadow-lg' : 'shadow-none',
                            animation,
                        )}
                        style={{ ...cornerStyle, ...popupWidth }}
                        ref={popupRef}
                    >
                        {data.content_type === '1' ? (
                            <ContentImage data={data} storeConfig={storeConfig} />
                        ) : (
                            <ContentCustom data={data} storeConfig={storeConfig} />
                        )}
                    </div>
                    <XCircleIcon
                        className={cx(
                            'cursor-pointer right-0 tablet:-right-5 -top-5 tablet:-top-4 absolute stroke-[2px]',
                            withbackdrop && overlayBackground !== '1' ? 'text-neutral-white' : 'text-primary',
                        )}
                        width={18}
                        height={18}
                        onClick={() => handleClosePopup(data)}
                    />
                </Dialog>
            )}
            {/* Custom CSS */}
            <style global jsx>
                {`${customCss}`}
            </style>
        </>
    );
};

export default Popup;
